<label class="label-above" [for]="name">{{ label | translate }}</label>

@switch (type) {
  @case ('text') {
    @if (control) {
      <input type="text" [formControl]="control" [id]="name" autocomplete="off" [placeholder]="placeholder || ''" />
    }
    @if (!control) {
      <input type="text" [id]="name" disabled />
    }
  }
  @case ('time') {
    @if (control) {
      <input type="time" [formControl]="control" [id]="name" autocomplete="off" />
    }
    @if (!control) {
      <input type="time" [id]="name" disabled />
    }
  }
  @case ('datetime-local') {
    @if (control) {
      <input type="datetime-local" [formControl]="control" [id]="name" autocomplete="off" />
    }
    @if (!control) {
      <input type="datetime-local" [id]="name" disabled />
    }
  }
  @case ('textarea') {
    @if (control) {
      <textarea [formControl]="control" [id]="name" autocomplete="off"></textarea>
    }
    @if (!control) {
      <textarea [id]="name" autocomplete="off" disabled></textarea>
    }
  }
}

@if (control) {
  <app-validation-message [control]="control"></app-validation-message>
}